import { render, staticRenderFns } from "./OrderDetailPrint.vue?vue&type=template&id=1ad2383e&"
import script from "./OrderDetailPrint.ts?vue&type=script&lang=js&"
export * from "./OrderDetailPrint.ts?vue&type=script&lang=js&"
import style0 from "./OrderDetailPrint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports